/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Error_Go_OnlineInputs */



/**
* | output |
* | --- |
* | "Failed to go back online" |
*
* @param {Offline_Error_Go_OnlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_error_go_online = /** @type {((inputs?: Offline_Error_Go_OnlineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Error_Go_OnlineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du retour en ligne")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al volver en línea")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao voltar online")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile tornare online")
	return /** @type {LocalizedString} */ ("Failed to go back online")
});